interface LogoProps {
  width?: number;
  height?: number;
}

function Logo({ width = 42, height = 38 }: LogoProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4068 24.5687L29.2338 5.92275L31.1535 5.89691L16.3696 27.4217L16.4068 24.5687Z"
        fill="#2B2D42"
      />
      <path
        d="M16.3697 27.4217C16.3632 28.0865 16.3403 28.7551 16.4281 29.4156C16.9807 28.8127 17.4018 28.0668 17.8685 27.3952L21.1161 22.6638L26.7331 14.4686L32.5581 5.93346C33.5136 5.81939 34.5905 5.91564 35.5573 5.91671H42L20.122 38L12.8422 37.9981L2.14819 22.1876L8.64942 22.2232L8.62934 7.47899L0 7.47133L0.0305546 0L24.8412 0.00481122L24.8106 7.47177L16.3458 7.47739L16.4069 24.5687L16.3697 27.4217Z"
        fill="#8D99AE"
      />
      <path
        d="M6.15407 1.66824L23.1584 1.69168L23.1325 5.82179L14.7752 5.82696C14.6533 6.0298 14.7632 13.6199 14.7636 14.4228L14.727 22.7701L14.7559 26.8927L11.4868 22.2161L10.3233 22.2234C10.3974 21.5132 10.3675 20.7779 10.3678 20.0641L10.3661 16.6772L10.3204 5.82153L3.91528 5.81065L2.31869 5.80851C2.13997 5.80709 1.85272 5.84033 1.69133 5.76689L1.69293 2.72842C1.69328 2.47986 1.62454 1.91635 1.72428 1.70157L6.15407 1.66824Z"
        fill="#CF0000"
      />
      <path
        d="M33.5488 7.52612L38.9689 7.52505L19.2338 36.3707L13.7233 36.3796L8.95634 29.3585L5.12158 23.7725L10.6666 23.7864L16.472 32.2723L33.5488 7.52612Z"
        fill="#C3D4D8"
      />
    </svg>
  );
}

export default Logo;
